/* src/app/components/payroll/purchase-request/purchase-request-filters/purchase-request-filters.component.css */
.search {
  display: flex;
  justify-content: end;
}
.ant-form-item {
  margin-bottom: 24px !important;
}
input::placeholder {
  color: rgb(217, 217, 217) !important;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
::ng-deep .custom-highlight {
  background-color: #e0e0e0;
  font-weight: 600;
  border-radius: 4px;
}
/*# sourceMappingURL=purchase-request-filters.component-X25T3GRJ.css.map */
